// SVG components (React); host scripts must not import this module.
import CartIcon from "@svg/cart.svg";
import ChecklistIcon from "@svg/checklist.svg";
import CloseXIcon from "@svg/close_x.svg";
import LinkToIcon from "@svg/link_to.svg";
import EmailIcon from "@svg/email.svg";
import FacebookIcon from "@svg/facebook.svg";
import FoodIcon from "@svg/food.svg";
import HeartIcon from "@svg/heart.svg";
import LeftIcon from "@svg/left.svg";
import PinterestIcon from "@svg/pinterest.svg";
import RightIcon from "@svg/right.svg";
import ShareIcon from "@svg/share.svg";
import TrashIcon from "@svg/trash.svg";
import TwitterIcon from "@svg/twitter.svg";
import CookwareIcon from "@svg/cookware.svg";
import WineIcon from "@svg/wine.svg";
import BookIcon from "@svg/book.svg";
import ChatIcon from "@svg/chat.svg";
import ChatAiIcon from "@svg/chat_ai.svg";

export const icons = {
  CART: {
    name: "cart",
    value: CartIcon,
  },
  CHECKLIST: {
    name: "checklist",
    value: ChecklistIcon,
  },
  CLOSE_X: {
    name: "close-x",
    value: CloseXIcon,
  },
  LINK_TO: {
    name: "link-to",
    value: LinkToIcon,
  },
  EMAIL: {
    name: "email",
    value: EmailIcon,
  },
  FACEBOOK: {
    name: "facebook",
    value: FacebookIcon,
  },
  FOOD: {
    name: "food",
    value: FoodIcon,
  },
  HEART: {
    name: "heart",
    value: HeartIcon,
  },
  LEFT: {
    name: "left",
    value: LeftIcon,
  },
  PINTEREST: {
    name: "pinterest",
    value: PinterestIcon,
  },
  RIGHT: {
    name: "right",
    value: RightIcon,
  },
  SHARE: {
    name: "share",
    value: ShareIcon,
  },
  TRASH: {
    name: "trash",
    value: TrashIcon,
  },
  TWITTER: {
    name: "twitter",
    value: TwitterIcon,
  },
  COOKWARE: {
    name: "cookware",
    value: CookwareIcon,
  },
  WINE: {
    name: "wine",
    value: WineIcon,
  },
  BOOK: {
    name: "book",
    value: BookIcon,
  },
  CHAT: {
    name: "chat",
    value: ChatIcon,
  },
  CHAT_AI: {
    name: "chat-ai",
    value: ChatAiIcon,
  },
};
